import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000/api"
});

axiosInstance.interceptors.request.use(
  (config) => {
    const storedToken = localStorage.getItem("token");
    let token;
    try {
      token = storedToken ? JSON.parse(storedToken) : null;
    } catch (error) {
      token = storedToken;
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
